module.exports = __webpack_public_path__ + "img/renewal.4fc611c2.png";